import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import EEArticle from "@ee/components/EEArticle";
import EEFooter from "@ee/components/EEFooterComponents/EEFooter";
import EENominationsDescription from "@ee/components/EENominationsDescription";
import EEOrganiserDetails from "@ee/components/EEOrganiserDetails";
import EERecognitionSection from "@ee/components/EERecognitionSection";
import EventsAwardsHeader from "@events-awards/components/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/components/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  AwardType,
  EventsAwardsLandingPageData,
} from "@events-awards/utils/types";

/**
 * Component to render EE page
 */
const EventsAwardsEEPageContent = ({
  articleProps,
}: EventsAwardsLandingPageData): React.ReactElement => {
  return (
    <div
      className="w-full"
      data-testid="events-awards-ee-page-content-component"
    >
      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.EE} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <EEArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <EERecognitionSection />

      <div className="mt-1 bg-gray-150 px-3 py-8 md:px-6 lg:px-0">
        <Container>
          <EENominationsDescription />
        </Container>
      </div>

      <EEOrganiserDetails />

      <EEFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsEEPageContent;
